<template>
  <div>
    <my-header :activeIndex="1" />
    <div style="position: relative;">
      <img src="../assets/game/top.jpg" style="width: 70%; margin-left: 15%" />
      <img src="../assets/game/button.png"  class="btn-go" @click="handleClickBtn"/>
    </div>
    <!-- <div class="bg-game">
      <div class="game">
        <div class="popAlert" v-for="(item, index) in topData" :key="index">
          <div class="game-img" ref="elememt">
            <img :src="item.url" alt="" />
            <div class="box">
              <div class="box-content">
                <p class="img">
                  <img :src="item.icon" />
                </p>
                <div class="box-text">{{ item.name }}</div>
                <div class="icon-img-flex-white" @click="open(item.android)">免费下载</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="soild_text_one game-main">
      <div class="soild_text_three">游戏列表</div>
    </div>
    <div class="center-game game-main">
      <div v-for="(item, index) in mainData" :key="index" class="main">
        <img :src="item.url" />
        <div class="game-box">
          <p class="name">{{ item.name }}</p>
          <p style="margin-bottom: 10px;">{{ item.text }}</p>
          <p>{{ item.text1 }}</p>
          <div class="down-game">
            <div class="icon-img-flex-black" @click="open('', index)">
              详细介绍
            </div>
            <div class="icon-img-flex-black" @click="open(item.android)">
              游戏下载
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <iframe
      width="100%" height="800" 
      src="https://h5game.longmaotech.com/?yisdk_param=nJ1hl8zoys_S0s-b&ext_param=ZJRuZqA%3D&tf_planid=1001"
    /> -->
    <!-- <div class="black"></div> -->
    <!-- <div class="bottom"></div> -->
    <my-footer />
    <my-top />
    <el-dialog title="详细介绍" :visible.sync="isVisible" class="dialog-box">
      <div class="content_box">
        <img :src="mainData[mainDataIndex].icon" />
        <div v-html="mainData[mainDataIndex].dialog_text" />
      </div>
      <p class="title">游戏介绍：</p>
      <p>{{ mainData[mainDataIndex].text1 }}</p>
      <p class="title">新区列表：</p>
      <div v-html="mainData[mainDataIndex].dialog_text1" />
      <p class="title">游戏特色：</p>
      <div v-html="mainData[mainDataIndex].content" />
    </el-dialog>
  </div>
</template>
<script>
import MyFooter from "./MyFooter.vue";
import MyHeader from "./MyHeader.vue";
import MyTop from "./MyTop.vue";
export default {
  name: "about",
  components: {
    "my-footer": MyFooter,
    "my-header": MyHeader,
    "my-top": MyTop,
  },
  data() {
    return {
      isVisible: false,
      notificationMessage: "操作成功！",
      hoverIndex: null,
      styleIndex: null,
      boxStyle: null,
      topData: [
        {
          url: require("../assets/game/top-01.png"),
          icon: require("../assets/index/icon-02.png"),
          name: "守护者之森",
          android: "https://down.longmaotech.com/source_apk/65/961.1.2024121616482195.apk",
        },
        // {
        //   url: require("../assets/game/top-02.png"),
        //   icon: require("../assets/index/icon-01.png"),
        //   name: "琴剑封魔录",
        //   android: "https://down.longmaotech.com/tf/msg_jc/66_158_1_1052.apk",
        // },
        // {
        //   url: require("../assets/game/top-03.png"),
        //   icon: require("../assets/index/icon-03.png"),
        //   name: "天之禁",
        //   android: "https://down.longmaotech.com/tf/lmminigame/103_856_1_1001.apk",
        // },
      ],
      mainDataIndex: 0,
      mainData: [
        {
          name: "守护者之森",
          url: require("../assets/game/main-01.jpg"),
          icon: require("../assets/game/icon-02.png"),
          text: "著作权人：上海绿岸网络科技股份有限公司；出版单位：上海绿岸网络科技股份有限公司；运营单位：上海绿岸网络科技股份有限公司；ISBN 978-7-7979-5156-2；",
          text1:
            "欢迎穿越时光，重返青葱岁月!集结5位伙伴，扮演年英雄激发小宇宙，与魔王大军战斗!建造秘密营地，钓鱼挖宝，收集儿时玩具，寻觅传说宝藏..",
          android:
            "https://down.longmaotech.com/source_apk/65/961.1.2024121616482195.apk",
          dialog_text:
            "著作权人：上海绿岸网络科技股份有限公司;</br>出版单位：上海绿岸网络科技股份有限公司；</br>运营单位：上海绿岸网络科技股份有限公司；</br>ISBN 978-7-7979-5156-2；",
          content:
            "【伙伴养成】：经典RPG卡牌养成，机甲战士、美少女;</br>【策略搭配】：Rouglike肉鸽玩法，职业+技能搭配多样!;</br>【关卡地图】：上天入地，百种关卡，穿越时空!等你来战!;</br>【小宇宙】：激发小宇宙成长，提升能量、突破上限!;</br>【寻宝】：收集玩具藏品，铁皮青蛙、照相小熊，感动重温!;</br>【钓鱼】：丰富鱼种、奇趣鱼缸，多样技能策略!等你体验!;</br>更多精彩玩法，持续火热推出、敬请期待！经典重现，快乐无价，让我们一起携手出发吧！",
          dialog_text1:
            "2024/12/01 萌新10服        2024/11/30 萌新9服        2024/11/29 萌新8服 </br>2024/11/28 萌新7服          2024/11/27 萌新6服        2024/11/26 萌新5服 ",
        },
        {
          name: "九州仙剑传",
          url: require("../assets/game/main-02.jpg"),
          icon: require("../assets/game/icon-01.png"),
          text: "著作权人：成都玖壹叁零网络科技有限公司；出版单位：上海同济大学电子音像出版社有限公司；运营单位：上海聚市网络科技有限公司；ISBN 978-7-498-07182-8；",
          text1:
            "以上古山海异兽为故事背景，配以唯美和绚丽的3D场景、角色、特效等视觉画面效果、玄幻风格的音乐，多方位展现出仙风道骨、侠骨柔肠的整体氛围，简单爽快的轻松仙侠类手游邀您一起畅游快意仙侠！",
          android: "https://down.longmaotech.com/tf/landing/89_548_1_1001.apk",
          dialog_text:
            "著作权人：成都玖壹叁零网络科技有限公司；;</br>出版单位：上海同济大学电子音像出版社有限公司；</br>运营单位：上海聚市网络科技有限公司；</br>ISBN 978-7-498-07182-8；",
          dialog_text1:
            "2024/12/10 灭仙1762服        2024/12/09 灭仙1761服        2024/12/08 灭仙1760服 </br>2024/12/07 灭仙1759服        2024/12/06 灭仙1758服        2024/12/05 灭仙1757服",
          content:
            "【独创奇遇玩法】</br>概率触发副本、异步PK、下注猜拳，更多创新玩点等你来体验！</br>【互动社交 星级体验】</br>通过超大无缝的地图，美轮美奂的场景，搭建全景泳池社交玩法，为玩家带来最为真实还原的社交沉浸体验。</br>同时场景内配备了花式各异的道具，视觉冲击力与气氛感爆棚！</br>【多重激情PK赛】</br>游戏中配置当下潮流段位积分赛玩法，各个服务器的玩家都能在一个场景进行1V1PK，通过累计比赛积分提升</br>至最强王者段位，直至称霸九州！</br>【十万元宝 登录就送】</br>海量福利来就送！行走江湖，囊中怎能羞涩？豪礼相赠，十万元宝登录领，更有极品光武等你拿！元宝，道具，</br>各种好礼送不停！",
        },
        {
          name: "异兽擎天",
          url: require("../assets/game/main-03.jpg"),
          icon: require("../assets/game/icon-03.png"),
          text: "著作权人：上海绿岸网络科技股份有限公司；出版单位：上海绿岸网络科技股份有限公司；运营单位：上海绿岸网络科技股份有限公司；ISBN 978-7-498-08390-6；",
          text1:
            "以战力养成为主，集合成宠物收集养成、PVE副本探索、PVP单区宗主，连服宗门，跨服争皇等玩法的H5国风Q版放置回合制手游 ！乖萌可爱，勇武有力，各具特色的几十种类型宠物皆可通过游戏内玩法免费获取，每种宠物都拥有专属的技能保驾护航！",
          android: "https://down.longmaotech.com/tf/landing/81_501_2_1001.apk",
          dialog_text:
            "著作权人：上海绿岸网络科技股份有限公司;</br>出版单位：上海绿岸网络科技股份有限公司；</br>运营单位：上海绿岸网络科技股份有限公司；</br>ISBN 978-7-498-08390-6；",
          dialog_text1:
            "2024/11/20 梦幻2175区        2024/11/19 梦幻2174区        2024/11/18 梦幻2173区 </br>2024/11/17 梦幻2172区        2024/11/16 梦幻2171区        2024/11/15 梦幻2170区    ",
          content:
            "【挂机系统】日常任务一键完成，还配上大量的金币和经验，让玩家专注体验游戏内容。<br>【宠物培养】60多种宠物，120多个技能，配合吞噬和洗练的宠物培养这是每个玩家的追求，是游戏里重要<br>的刺激消费系统。<br>【装备锻造】在游戏里打BOSS获得大量的装备分解成洗练石强化装备等级，为装备升星增加更多的战斗力也<br>是参与游戏必定的玩法。<br>【天仙系统】上古神女，为单人任务保驾护航，在日常任务获取天仙进阶丹即可获得强大战力的天仙。<br>【护肝养肝】日常任务一键完成，专注游戏各种体验<br>【轻松收集】各色神话人物宠物为你所用，闯荡仙界不再孤单<br>【自由社交】结识修仙好友， 不仅可以结伴共闯副本，互助完成任务，还可以组建修仙家族，共享修仙乐趣。",
        },
      ],

    };
  },
  methods: {
    handleClickBtn(){
      this.$router.replace("/news");
    },
    hideModal() {
      this.isVisible = false;
    },
    open(url, index) {
      if (url == "") {
        this.isVisible = true;
        this.mainDataIndex = index;
      } else {
        window.open(url);
      }
    },
    mouseenter(event, index) {
      let { offsetY } = event;
      let { offsetHeight } = this.$refs.elememt[index];
      let mouseenHeight = offsetHeight - offsetY;
      if (mouseenHeight > 70) {
        this.hoverIndex = index;
        this.boxStyle = "bottom: 0;";
      } else {
        this.hoverIndex = null;
        this.infoStyle = null;
      }
    },
    hideText() {
      this.hoverIndex = null;
      this.infoStyle = null;
    },
  },
};
</script>
<style>
iframe {
  border: none;
}
</style>
<style scoped>
@import url(../../css/game.min.css);
.btn-go{
  position: absolute;
  right: 25%;
  bottom: 20%;
  cursor: pointer;
}
.content_box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.dialog-box .title {
  color: blueviolet;
  font-weight: bold;
  margin: 10px 0;
}
.content_box img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.black {
  background-color: #000;
  height: 60px;
  position: relative;
  bottom: 60px;
}
.bottom {
  background: url("../assets/game/bottom.png");
  height: 60px;
  position: relative;
  bottom: 60px;
}
.game-main {
  margin: 0 auto;
}
.box-content {
  width: 50%;
}
.soild_text_three {
  position: relative;
  text-align: center;
  margin: 10px auto;
  height: 20px;
  font-size: 14px;
  color: #7bc4cc;
}
.soild_text_three::before {
  content: "";
  position: absolute;
  top: 50%;
  border: solid 1px #c5e3e8;
  width: 45%;
  left: 0;
}
.soild_text_three::after {
  content: "";
  position: absolute;
  top: 50%;
  border: solid 1px #c5e3e8;
  width: 45%;
  right: 0;
}
.main {
  display: flex;
  border-bottom: solid 2px #c5e3e8;
  margin-bottom: 20px;
  padding-bottom: 20px;
  justify-content: center;
}
.center-game .main:last-of-type {
  border: none;
}
.main img {
  margin-right: 20px;
}
.main .game-box {
  width: 60%;
  line-height: 25px;
  font-size: 15px;
}
.main .game-box .name {
  border-left: orangered solid 2px;
  padding-left: 10px;
  line-height: 15px;
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 18px;
}
.down-game {
  display: flex;
  justify-content: end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/game.vue